import { TabHeaderStyled } from './TabHeader.styles';
import { useLayoutEffect, useRef } from 'react';
interface TabHeaderProps {
  onClick: (index: number) => void;
  onWidthChange: (index: number, width: number | undefined) => void;
  label: string;
  forceWidth: number | undefined;
  active: boolean;
  index: number;
}

export const TabHeader = ({
  onClick,
  onWidthChange,
  label,
  forceWidth,
  active,
  index,
}: TabHeaderProps) => {
  const PADDING = 15;
  const elementRef = useRef<HTMLDivElement | null>(null);

  const resizeObserverRef = useRef<ResizeObserver | undefined>(undefined);

  const latestWidthRef = useRef<number | undefined>(undefined);

  useLayoutEffect(() => {
    const spanElement = elementRef.current;
    if (!spanElement) {
      return;
    }

    const box = spanElement.getBoundingClientRect();
    const width = Math.round(box.width) + PADDING * 2;

    if (width !== latestWidthRef.current) {
      latestWidthRef.current = width;
      onWidthChange(index, width);
    }
  }, [label, index, onWidthChange]);

  useLayoutEffect(() => {
    const spanElement = elementRef.current;
    if (!spanElement) {
      return;
    }

    resizeObserverRef.current = new ResizeObserver((entries) => {
      const [entry] = entries;
      const width = Math.round(entry.contentRect.width) + PADDING * 2;
      if (width !== latestWidthRef.current) {
        latestWidthRef.current = width;
        onWidthChange(index, width);
      }
    });

    resizeObserverRef.current.observe(spanElement);

    return () => {
      resizeObserverRef.current?.unobserve(spanElement);
      resizeObserverRef.current = undefined;
      onWidthChange(index, undefined);
      latestWidthRef.current = undefined;
    };
  }, [index, onWidthChange]);
  return (
    <TabHeaderStyled
      key={index}
      active={active}
      onClick={() => onClick(index)}
      style={forceWidth ? { width: `${forceWidth}px` } : undefined}
      data-testid={`${label}-tab`}
    >
      <span
        ref={elementRef}
        style={{ whiteSpace: 'nowrap', display: 'inline-block' }}
      >
        {label}
      </span>
    </TabHeaderStyled>
  );
};
